<template>
  <div>
    <footer :class="theme === 'dark' ? 'footer-dark' : 'footer-light'" style="line-height: 1.8" v-if="!size">
      <div class="container w1200">
        <el-row>
          <el-col :span="4">
            <h4 class="p-l-30">帮助中心</h4>
            <el-divider />
            <h5 class="p-l-30">
              <a class="cursor-pointer" href="https://www.zhongke3.com/p/help?helpName=app下载" target="_blank">App下载</a>
            </h5>
            <h5 class="p-l-30">
              <a class="cursor-pointer" href="https://www.zhongke3.com/p/help?id=b94df44fa8ab45548634f1d5e022cca3" target="_blank">账号注册</a>
            </h5>
            <h5 class="p-l-30">
              <a class="cursor-pointer" href="https://www.zhongke3.com/p/help?helpName=购买课程" target="_blank">购买课程</a>
            </h5>
            <h5 class="p-l-30">
              <a class="cursor-pointer" href="https://www.zhongke3.com/p/help?helpName=如何学习" target="_blank">如何学习</a>
            </h5>
            <h5 class="p-l-30">
              <a class="cursor-pointer" href="https://www.zhongke3.com/p/feedback" target="_blank">问题反馈</a>
            </h5>
          </el-col>
          <el-col :span="4">
            <h4>关于我们</h4>
            <el-divider />
            <h5><a href="https://www.zhongke3.com/" target="_blank">公司官网</a></h5>
            <h5>
              <a href="https://www.zhongke3.com/p/login/protocol?type=1" target="_blank">用户协议</a>
            </h5>
            <h5>
              <a href="https://www.zhongke3.com/p/login/protocol?type=2" target="_blank">隐私政策</a>
            </h5>

            <h5>
              <a href="https://www.zhongke3.com/p/login/protocol?type=3" target="_blank">免责声明</a>
            </h5>
          </el-col>
          <!-- <el-col :span="7">
          <h4></h4>
          <el-divider />
          <h5>客服投诉电话：400-878-7501</h5>
          <h5 style="white-space:nowrap;">企业邮箱：4006226969@zhongjianedu.com</h5>
        </el-col> -->
          <el-col class="center-box" :span="3">
            <h4 style="position: relative">
              &nbsp;<span style="font-size: 16px; position: absolute; left: 0; width: 300%; text-align: left"
                >客服投诉电话：400-878-7501</span
              >
            </h4>
            <el-divider />
            <div class="qr-view">
              <img :src="$imgsrc('app_download_qr.png')" />
            </div>
            <h6>APP二维码</h6>
          </el-col>
          <el-col class="center-box" :span="4">
            <h4>&nbsp;</h4>
            <el-divider />
          </el-col>
          <el-col class="center-box" :span="3">
            <h4>&nbsp;</h4>
            <el-divider />
            <div class="qr-view">
              <img :src="$imgsrc('footer_official_accounts_qr.png')" />
            </div>
            <h6>中课网校</h6>
          </el-col>
          <el-col class="center-box" :span="3">
            <h4>&nbsp;</h4>
            <el-divider />
            <div class="qr-view" style="padding: 0px">
              <img src="@/assets/publicity1/qr_yjs.jpg" style="width: 108px; height: 108px" />
            </div>
            <h6>中课在职研究生</h6>
          </el-col>
          <el-col class="center-box" :span="3">
            <h4>&nbsp;</h4>
            <el-divider />
            <div class="qr-view">
              <img :src="$imgsrc('footer_group_qr.png')" />
            </div>
            <h6>中课网校考证指导</h6>
          </el-col>
        </el-row>
        <div class="row m-t-20 m-b-5">
          <el-divider />
        </div>
        <div class="row link-ul m-b-15">
          <ul class="youqing-box">
            <li class="title">友情链接：</li>
            <li>
              <a rel="nofollow" href="http://www.mohurd.gov.cn/" target="_blank">全国住建部官网</a>
            </li>
            <li>
              <a rel="nofollow" href="http://jzsc.mohurd.gov.cn/asite/jsbpp/index" target="_blank">全国建筑市场监管公共服务平台</a>
            </li>
            <li>
              <a rel="nofollow" href="http://www.cpta.com.cn/" target="_blank">中国人事考试网</a>
            </li>

            <!-- <li>
            <a href="http://www.zhongjianedu.net/" target="_blank">中课网校官方网站</a>
          </li> -->
            <li>
              <a rel="nofollow" href="http://www.mohrss.gov.cn/" target="_blank">中华人民共和国人力资源和社会保障部</a>
            </li>
            <li>
              <a rel="nofollow" href="http://www.hnrsks.com/" target="_blank">河南人事考试中心</a>
            </li>
          </ul>
        </div>
        <div class="row m-t-20 m-b-0">
          <el-divider />
        </div>
        <div class="row m-t-0 text-center copy-right">
          <p>
            <a class="record" href="http://beian.miit.gov.cn/" target="_blank">豫ICP备09016314号-1 中课网校</a>
          </p>
        </div>
      </div>
    </footer>
    <div class="footer small" v-if="size === 'small'">
      <div class="nav-list">
        <ul>
          <li><a href="">关于我们</a></li>
          <li>┊</li>
          <li><a href="">了解中课网校</a></li>
          <li>┊</li>
          <li><a href="">加入我们</a></li>
          <li>┊</li>
          <li><a href="">投诉建议</a></li>
          <li>┊</li>
          <li><a href="">免责声明</a></li>
          <li>┊</li>
          <li><a href="">帮助中心</a></li>
          <li>┊</li>
          <li><a href="">售后服务</a></li>
          <li>┊</li>
          <li><a href="">问题反馈</a></li>
          <li>┊</li>
          <li><a href="">APP下载</a></li>
        </ul>
      </div>
      <div class="friendship">
        <ul>
          <li>友情链接：</li>
          <li>
            <a rel="nofollow" href="http://www.mohurd.gov.cn/" target="_blank">全国住建部官网</a>
          </li>
          <li>
            <a rel="nofollow" href="http://jzsc.mohurd.gov.cn/asite/jsbpp/index" target="_blank">全国建筑市场监管公共服务平台</a>
          </li>
          <li>
            <a rel="nofollow" href="http://www.cpta.com.cn/" target="_blank">中国人事考试网</a>
          </li>
          <!-- <li>
          <a href="http://www.zhongjianedu.net/" target="_blank">中课网校官方网站</a>
        </li> -->
          <li>
            <a rel="nofollow" href="http://www.mohrss.gov.cn/" target="_blank">中华人民共和国人力资源和社会保障部</a>
          </li>
          <li>
            <a rel="nofollow" href="http://www.hnrsks.com/" target="_blank">河南人事考试中心</a>
          </li>
        </ul>
      </div>
      <a class="record" href="http://beian.miit.gov.cn/" target="_blank">豫ICP备2021007352号-1 中课网校</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      validator: function (t) {
        return t === 'light' || t === 'dark'
      },
      default: 'light'
    }
  }
}
</script>

<style lang="scss" scoped>
.footer.small {
  padding: 35px 0 12px 0;
  background-color: #fff;

  .nav-list {
    ul {
      display: flex;
      color: #666666;
      font-size: 12px;
      align-items: center;
      justify-content: center;

      li {
        margin: 2px;
      }
    }
  }

  .friendship {
    margin-top: 10px;

    ul {
      display: flex;
      color: #999999;
      font-size: 12px;
      align-items: center;
      justify-content: center;

      li {
        margin: 2px;
      }
    }
  }

  .record {
    margin-top: 10px;
    color: #999999;
    font-size: 12px;
    text-align: center;
  }
}

.footer-light {
  background: #ffffff;

  .container {
    h4,
    h5,
    h6,
    p {
      color: #666666;
    }

    :deep .el-divider {
      border-top: 1px solid #626161;
    }

    .qr-view {
      background-color: #fff;

      img {
        width: 100px;
        height: 100px;
      }
    }

    .youqing-box {
      .title {
        color: #c2c2c2;
      }

      li + li {
        color: #c2c2c2;
      }
    }
  }
}

.footer-dark {
  background: #333333;

  .container {
    h4,
    h5,
    h6,
    p {
      color: #ffffff;
    }

    :deep .el-divider {
      background-color: #838383;
    }

    .qr-view {
      background-color: #fff;

      img {
        width: 100px;
        height: 100px;
      }
    }

    .youqing-box {
      .title {
        color: #ffffff;
      }

      li + li {
        color: #c2c2c2;
      }
    }
  }
}

.container {
  padding-top: 34px;
  padding-bottom: 24px;

  h4 {
    font-size: 18px;

    font-weight: 400;
  }

  h5 {
    font-size: 14px;

    font-weight: 400;
  }

  .qr-view {
    margin: 0 auto;
    width: 100px;
    display: flex;
    padding: 4px;
    margin-bottom: 10px;
  }

  .center-box {
    text-align: center;
  }

  h6 {
    font-size: 14px;

    font-weight: 400;
  }

  .youqing-box {
    display: flex;
    justify-content: center;
    line-height: 20px;

    li {
      font-size: 12px;

      font-weight: 400;
    }

    li + li {
      margin-left: 10px;
    }

    .title {
      font-size: 14px;
    }
  }
}
</style>
